import { REACT_APP_API_URL } from "../configs/config";

const getUsers = async (payload) => {
  const { pageIndex, pageSize, token, email, username, role, displayName, deviceOS, isVerified, appVersion } = payload;
  
  // Build query params
  const queryParams = new URLSearchParams();
  if (email) queryParams.append('email', email);
  if (username) queryParams.append('username', username);
  if (role) queryParams.append('role', role);
  if (displayName) queryParams.append('displayName', displayName);
  if (deviceOS) queryParams.append('deviceOS', deviceOS);
  if (appVersion) queryParams.append('appVersion', appVersion);
  if (isVerified !== undefined && isVerified !== null && isVerified !== '') {
    queryParams.append('isVerified', String(isVerified));
  }
  
  const queryString = queryParams.toString();
  const url = `${REACT_APP_API_URL}user/admin/search/${pageIndex}/${pageSize}${queryString ? `?${queryString}` : ''}`;
  
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  
  const responseJson = await response.json();
  return responseJson;
};

const updateUser = async (payload) => {
  const { userId, userData, token } = payload;
  
  // Ensure userId is a string
  const userIdStr = String(userId);
  
  const response = await fetch(
    `${REACT_APP_API_URL}admin/users/${userIdStr}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(userData),
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

const deleteUser = async (payload) => {
  const { userId, token } = payload;
  
  // Ensure userId is a string
  const userIdStr = String(userId);
  
  const response = await fetch(
    `${REACT_APP_API_URL}admin/users/${userIdStr}`,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

const resetUserPassword = async (payload) => {
  const { userId, newPassword, token } = payload;
  
  // Ensure userId is a string
  const userIdStr = String(userId);
  
  const response = await fetch(
    `${REACT_APP_API_URL}admin/users/${userIdStr}/reset-password`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ newPassword }),
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

const deleteMultipleUsers = async (payload) => {
  const { userIds, token } = payload;
  
  const response = await fetch(
    `${REACT_APP_API_URL}admin/users/bulk-delete`,
    {
      method: "POST", // Changed from DELETE to POST
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ userIds }),
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

const deleteUserDataOnly = async (payload) => {
  const { userId, token } = payload;
  
  // Ensure userId is a string
  const userIdStr = String(userId);
  
  const response = await fetch(
    `${REACT_APP_API_URL}admin/users/${userIdStr}/data`,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

const updateUserCheckInAndReferral = async (payload) => {
  const { userId, checkInData, token } = payload;
  
  // Ensure userId is a string
  const userIdStr = String(userId);
  
  const response = await fetch(
    `${REACT_APP_API_URL}admin/users/${userIdStr}/checkin-referral`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(checkInData),
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

const getUserWallets = async (payload) => {
  const { userId, token } = payload;

  const response = await fetch(
    `${REACT_APP_API_URL}admin/users/${userId}/wallets`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );

  const responseJson = await response.json();
  return responseJson;
};

const assignSubscription = async (payload) => {
  const { userId, productId, platform, durationMonths, transactionId, note, token } = payload;
  
  const requestBody = {
    userId: String(userId),
    productId,
    platform,
    ...(durationMonths && { durationMonths }),
    ...(transactionId && { transactionId }),
    ...(note && { note })
  };
  
  const response = await fetch(
    `${REACT_APP_API_URL}subscription/admin/assign`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(requestBody),
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

const resetPremium = async (payload) => {
  const { userId, token } = payload;
  const userIdStr = String(userId);

  const response = await fetch(
    `${REACT_APP_API_URL}subscription/admin/user/${userIdStr}/reset-premium`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );

  const responseJson = await response.json();
  return responseJson;
};

export { getUsers, updateUser, deleteUser, resetUserPassword, deleteMultipleUsers, deleteUserDataOnly, updateUserCheckInAndReferral, getUserWallets, assignSubscription, resetPremium };
